export const UnallocatedCoachNames = [
    '-',
    'Unallocated Senior Associate',
    'Unallocated Senior Associate 2',
    'Unallocated Manager',
    'Unallocated Senior Manager',
    'Unallocated Senior Manager 2',
    'Unallocated Managing Director',
    'Unallocated Director',
];
